/* eslint-disable max-len */
import React from 'react';

interface LeftArrowProps {
  className?: string;
  width?: number;
  height?: number;
}

const LeftArrowIcon = function LeftArrowIcon({
  className,
  width,
  height,
}: LeftArrowProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 32 32"
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M31.1319 16H16.5809L21.9571 10.6238L20.5429 9.20954L13.4596 16.2929L12.7524 17L13.4596 17.7071L20.5429 24.7904L21.9571 23.3762L16.5809 18H31.1319C30.6188 25.3574 24.4878 31.1666 17 31.1666C9.17596 31.1666 2.83333 24.824 2.83333 17C2.83333 9.17595 9.17596 2.83331 17 2.83331C24.4878 2.83331 30.6188 8.64257 31.1319 16Z" fill="#798897" />
    </svg>
  );
};

LeftArrowIcon.defaultProps = {
  className: '',
  width: 24,
  height: 24,
};

export default LeftArrowIcon;
